import { render, staticRenderFns } from "./CustomEditForm.vue?vue&type=template&id=4b5602db&scoped=true"
import script from "./CustomEditForm.vue?vue&type=script&lang=js"
export * from "./CustomEditForm.vue?vue&type=script&lang=js"
import style0 from "./CustomEditForm.vue?vue&type=style&index=0&id=4b5602db&prod&lang=scss&scoped=true"
import style1 from "./CustomEditForm.vue?vue&type=style&index=1&id=4b5602db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5602db",
  null
  
)

export default component.exports